import classNames from 'classnames'
import htmlReactParser from 'html-react-parser'
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html'
import { isValidElement, ReactNode } from 'react'
import Card from 'react-bootstrap/Card'
import reactStringReplace from 'react-string-replace'
import YouTube from 'react-youtube'

import styles from './Description.module.scss'

type Props = {
  children: unknown
}

const Description = ({ children }: Props) => {
  if (!children) return null

  // Quill format
  if (typeof children === 'object' && 'ops' in children) {
    const delta = children as { ops: any[] }
    const converter = new QuillDeltaToHtmlConverter(delta.ops, {})
    const html = converter.convert()
    return (
      <Card className={classNames(styles.description, 'shadow-sm')}>
        <Card.Body className={styles.quillBody}>{htmlReactParser(html)}</Card.Body>
      </Card>
    )
  }

  // Replace YouTube links with embedded videos
  const newChildren =
    typeof children === 'string'
      ? reactStringReplace(children, /https:\/\/www.youtube.com\/watch\?v=([\w-]+)/g, (match) => (
          <YouTube videoId={match} />
        ))?.map((child) => (isValidElement(child) ? child : child ? htmlReactParser(child as string) : null))
      : children

  return (
    <Card className={classNames(styles.description, 'shadow-sm')}>
      <Card.Body>{newChildren as ReactNode}</Card.Body>
    </Card>
  )
}

export default Description
